import { NavLink, useLocation } from "react-router-dom";
import { NAV_LINKS, isNavLinkActive } from "@routes/navLinks";
import useTranslations from "@hooks/useTranslations";

const MainMenu = () => {
  const location = useLocation();
  const t = useTranslations();

  return (
    <div className="text-right">
      <div className="bostami-main-menu-wrap">
        <nav className="bastami-main-menu">
          <ul>
            {NAV_LINKS.map((link) => (
              <li
                key={link.path}
                className={isNavLinkActive(link, location.pathname) ? "active" : ""}
              >
                <NavLink to={link.path}>
                  <span>
                    <i className={link.icon} />
                  </span>
                  {t.nav[link.labelKey]}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MainMenu;
